<div *ngIf="!busy && !connected">
    <div class="row margin-top-8">
        <div class="col-md-4 label">
            {{'general.username' | translate}}:
        </div>
        <div class="col-md-8">
            <div class="p-inputgroup">
                <input type="text" pInputText [(ngModel)]="username"/>
            </div>
        </div>
    </div>
    <div class="row margin-top-8">
        <div class="col-md-4 label">
            {{'general.password' | translate}}:
        </div>
        <div class="col-md-8">
            <div class="p-inputgroup">
                <input type="text" pInputText [(ngModel)]="password"/>
            </div>
        </div>
    </div>

    <div class="row margin-top-8">
        <div class="col-md-4 label">
        </div>
        <div class="col-md-8">
            <button type="button" (click)="SaveSettings()" class="btn btn-primary"
                    [disabled]="password === null || username === null || username.length === 0 || password.length === 0">
                Connect to Northmill
            </button>
        </div>
    </div>

</div>
